import React, { useEffect } from 'react';
import ReactModal from 'react-modal';
import styled from 'styled-components';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  justify-content: ${(p) => (p.centered ? 'center' : 'space-between')};
`;

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 1000,
  },
  content: {
    inset: '50% auto auto 50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    background: 'transparent',
    padding: 0,
    overflow: 'visible',
  },
};

const StyledModal = ({
  isOpen,
  onBackgroundClick,
  onEscapeKeydown,
  centered,
  className,
  children,
  onAfterOpen,
  onAfterClose,
  shouldCloseOnOverlayClick,
  shouldCloseOnEsc,
  ariaHideApp = true,
  appElementSelector = '#root',
  ...rest
}) => {
  useEffect(() => {
    if (typeof document !== 'undefined' && ariaHideApp) {
      const root = document.querySelector(appElementSelector);
      if (root) ReactModal.setAppElement(root);
    } else {
      ReactModal.setAppElement(null);
    }
  }, [ariaHideApp, appElementSelector]);

  const handleRequestClose = (e) => {
    if (onBackgroundClick) onBackgroundClick(e);
    if (onEscapeKeydown) onEscapeKeydown(e);
    if (typeof rest.onRequestClose === 'function') rest.onRequestClose(e);
  };

  return (
    <ReactModal
      isOpen={!!isOpen}
      onAfterOpen={onAfterOpen}
      onAfterClose={onAfterClose}
      onRequestClose={handleRequestClose}
      shouldCloseOnOverlayClick={
        typeof shouldCloseOnOverlayClick === 'boolean'
          ? shouldCloseOnOverlayClick
          : !!onBackgroundClick
      }
      shouldCloseOnEsc={
        typeof shouldCloseOnEsc === 'boolean'
          ? shouldCloseOnEsc
          : !!onEscapeKeydown
      }
      style={modalStyles}
      {...rest}
    >
      <Content centered={centered} className={className}>
        {children}
      </Content>
    </ReactModal>
  );
};

export default StyledModal;
